import {
  ChevronLeftIcon,
  ChevronRightIcon,
  RepeatIcon
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Grid,
  IconButton,
  Stack,
  Text
} from "@chakra-ui/react";
import { GetLayout } from "components/get-layout";
import { Toast } from "components/toast";
import { usePromiseData } from "hooks/use-promise-data";
import { RoutePermissionFunction } from "router-manager/parts";
import { useRouter } from "router-manager/parts";
import { PipelineListEndpoints } from "../../../components/pipelines-list-components/endpoints";
import { SkeletonLoading } from "components/skeleton-loading";
import { PipelineListCard } from "components/pipelines-list-components/pipeline-list-card";

const PAGE_SIZE = 9;

export default function PipelineListPage() {
  const router = useRouter();
  const { result, isLoading, onUpdate, currentPage, nextPage, prevPage } =
    usePromiseData(
      (pageNumber) => PipelineListEndpoints.getPipelines(pageNumber, PAGE_SIZE),
      {
        onError: (e: any) => {
          const errorMessage = e?.response?.data?.message;

          Toast({
            title: "Erro ao carregar pipelines",
            description: errorMessage,
            status: "error"
          });
        }
      }
    );

  const pipelines = result ?? [];
  const hasNextPage = pipelines.length === PAGE_SIZE;

  return (
    <GetLayout
      title="Lista de Pipelines"
      pageContentProps={{ bg: "#ECEEF2", p: "24px" }}
      rightContent={
        <Button
          onClick={() => onUpdate()}
          isLoading={isLoading}
          leftIcon={<RepeatIcon />}
        >
          Atualizar
        </Button>
      }
    >
      <Stack spacing="20px">
        {isLoading ? (
          <Grid templateColumns="1fr 1fr 1fr" gap="16px">
            {Array.from({ length: 3 }).map((_, index) => (
              <SkeletonLoading key={index} h="230px" isLoading={isLoading} />
            ))}
          </Grid>
        ) : pipelines.length ? (
          <>
            <Grid templateColumns="1fr 1fr 1fr" gap="20px">
              {pipelines.map((pipeline) => (
                <PipelineListCard
                  key={pipeline.id}
                  pipeline={pipeline}
                  onEdit={() =>
                    router.push(`/mailing/pipeline/${pipeline.idMailing}`)
                  }
                  onDelete={() => {
                    Toast({
                      title: "Exclusão de pipeline não implementada",
                      status: "warning"
                    });
                  }}
                />
              ))}
            </Grid>
            {(currentPage > 0 || hasNextPage) && (
              <Flex w="100%" justifyContent="center">
                <Flex alignItems="center" gap="10px">
                  <IconButton
                    aria-label="página anterior"
                    variant="outline"
                    icon={<ChevronLeftIcon />}
                    onClick={() => prevPage()}
                    disabled={currentPage === 0}
                  />
                  <Text fontSize="15px" fontWeight="500">
                    {currentPage + 1}
                  </Text>
                  <IconButton
                    variant="outline"
                    aria-label="próxima página"
                    icon={<ChevronRightIcon />}
                    onClick={() => nextPage()}
                    disabled={!hasNextPage}
                  />
                </Flex>
              </Flex>
            )}
          </>
        ) : (
          <Box
            bg="white"
            border="1px solid #CBD5E0"
            borderRadius="16px"
            p="24px"
            textAlign="center"
          >
            <Text color="#4A5568" fontSize="18px" fontWeight="500">
              Nenhum pipeline encontrado.
            </Text>
          </Box>
        )}
      </Stack>
    </GetLayout>
  );
}

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.setUserTypesPermission([
    "SUPER",
    "REGIONAL",
    "COMERCIAL",
    "PARCEIRO_GERENTE_ESTRATEGICO",
    "PARCEIRO_GERENTE_VAREJO",
    "PARCEIRO_MASTER",
    "ASCOM"
  ]);
  route.setColomboUserTypesPermission([
    "COMERCIAL",
    "PARCEIRO_MASTER",
    "PARCEIRO_VENDEDOR"
  ]);
};
